import i18n from 'simple-react-i18n'
import Row from '../../../../components/react/Row'
import RadioButtons from '../../../../components/forms/RadioButtons'
import { getLabel } from '../../../../utils/StoreUtils'
import Input from '../../../../components/forms/Input'
import { getDate, getDateWithHour, getHour } from '../../../../utils/DateUtil'
import { onChangeDate, onChangeHour, setMessageModal } from '../../../../utils/FormUtils'
import React, { useState } from 'react'
import { getLogin } from '../../../../utils/SettingUtils'
import { WhiteCard } from '../../../../components/styled/Card'
import Button from '../../../../components/forms/Button'
import HydrometryAction from '../../../actions/HydrometryAction'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { DELETE, HYDRO_MEASURE_COTE, PURGE, RESET } from '../../../constants/HydrometryConstants'
import ConfirmModal from '../../../../components/modal/ConfirmModal'
import ToastrAction from '../../../../toastr/actions/ToastrAction'
import { isNil } from 'lodash'
import { StyledFieldSet, StyledLegend } from '../../../../components/StyledElements'
import { Grid2 } from '@mui/material'
import { measureHydroType, validationSelectFiltersType } from '../../../shapes/HydroShapes'
import ValidationSeeMoreCriterias from '../validationUtils/ValidationSeeMoreCriterias'

const DeleteHydroToolPanel = ({
    id,
    dataType,
    selectedCodePoint,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    isChange,
    setIsChange,
    isPreview,
    setIsPreview,
    measuresSelectedByFilters,
    createTechnicalEvent,
    displayModes,
    nextMeasure,
    selectFilters,
    changeSelectFilters,
    useNGF = false,
    landmarkValue,
}) => {
    const [deleteMode, setDeleteMode] = useState('reset')
    const [modalOpen, setModalOpen] = useState(false)

    const dispatch = useDispatch()

    const {
        users,
    } = useSelector(store => ({
        users: store.UserReducer.users,
    }), shallowEqual)

    const user = users.find(u => u.login === getLogin())

    const deleteModesObj = [
        { code: RESET, name: i18n.reseting },
        { code: DELETE, name: i18n.deleting },
        user.admin === '1' ? { code: PURGE, name: i18n.purge } : null,
    ].filter(m => !!m)

    const onValidate = () => {
        if (!displayModes.brute) {
            setMessageModal('Veuillez passer en mode "Brute" pour valider les données (choix des courbes au dessus du graphique)')
        } else if (!startDate || !endDate) {
            dispatch(ToastrAction.warning(i18n.datesNoSelected))
        } else {
            setIsPreview(true)
        }
    }

    const onCancel = () => {
        setIsPreview(false)
    }

    const resetSave = () => {
        setIsPreview(false)
        setIsChange(!isChange)
    }

    const getSelectFilters = () => {
        return {
            ...selectFilters,
            displayCote: useNGF ? HYDRO_MEASURE_COTE.NGF : HYDRO_MEASURE_COTE.HEIGHT,
            landmarkValue,
        }
    }

    // eslint-disable-next-line consistent-return
    const onSave = () => {
        if (!displayModes.brute) {
            setMessageModal('Veuillez passer en mode "Brute" pour valider les données (choix des courbes au dessus du graphique)')
        } else {
            switch (deleteMode) {
                case PURGE:
                    setModalOpen(true)
                    return (
                        <ConfirmModal
                            isOpen={modalOpen}
                            title={i18n.purgeRawMeasuresConfirmation}
                            onValidate={
                                dispatch(HydrometryAction.purgeHydroMeasures(
                                    id, { startDate, endDate }, dataType, selectedCodePoint, getSelectFilters(), () => {
                                        resetSave()
                                        createTechnicalEvent({ mode: 'purge' })
                                    }))
                            }
                            onClose={() => setModalOpen(false)}
                        />
                    )
                case DELETE:
                    setModalOpen(true)
                    return (
                        <ConfirmModal
                            isOpen={modalOpen}
                            title={i18n.deleteMeasuresConfirmation}
                            onValidate={
                                dispatch(HydrometryAction.deleteHydroMeasures(
                                    id, measuresSelectedByFilters, () => {
                                        createTechnicalEvent({ mode: 'delete' })
                                    })).then(() => {
                                    if (!isNil(nextMeasure)) {
                                        dispatch(HydrometryAction.updateMeasures([{ ...nextMeasure, initialPoint: 1 }]))
                                    }
                                    resetSave()
                                })
                            }
                            onClose={() => setModalOpen(false)}
                        />
                    )
                case RESET:
                    setModalOpen(true)
                    return (
                        <ConfirmModal
                            isOpen={modalOpen}
                            title={i18n.resetConfirmation}
                            onValidate={
                                dispatch(HydrometryAction.resetHydroMeasures(
                                    id, { startDate, endDate }, dataType, selectedCodePoint, getSelectFilters(), () => {
                                        resetSave()
                                        createTechnicalEvent({ mode: 'reset' })
                                    }))
                            }
                            onClose={() => setModalOpen(false)}
                        />
                    )
                default:
                    break
            }
        }
    }

    return (
        <div>
            <WhiteCard title={ i18n.deleteMode } round>
                <Row>
                    <RadioButtons col={ 12 } elements={ deleteModesObj } onChange={ v => setDeleteMode(v) } selected={ deleteMode } disabled={ isPreview }/>
                </Row>
            </WhiteCard>
            <div className='padding-top-1'/>
            <WhiteCard title={ getLabel(deleteModesObj, deleteMode) } round>
                <div className='padding-top-1'/>
                <StyledFieldSet style={{ margin: '10px', backgroundColor: '#d9dfe4' }}>
                    <StyledLegend>{i18n.selectionCriteria}</StyledLegend>
                    <Grid2 container alignItems='center'>
                        <Button
                            tooltip={ i18n.selectRange }
                            className={ `validToolBtn margin-right-1` }
                            onClick={ () => {
                                setStartDate(undefined)
                                setEndDate(undefined)
                            } }
                            icon='settings_ethernet'
                            disabled={ isPreview }
                        />
                        <Grid2 sx={{ paddingLeft: '10px', fontWeight: 'bolder' }} className='padding-left-1 bold'>{ measuresSelectedByFilters.length } { measuresSelectedByFilters.length > 1 ? i18n.selectedMeasures : i18n.selectedMeasure }</Grid2>
                    </Grid2>
                    <Grid2 container spacing={1} sx={{ paddingTop: '10px', paddingLeft: '10px', paddingRigth: '10px' }}>
                        <Grid2 size={6}>
                            <Input
                                title={ i18n.startDate }
                                id='startDate'
                                value={ getDate(startDate)}
                                onChange={ v => {
                                    onChangeDate(v, v2 => {
                                        return setStartDate(getDateWithHour(v2, startDate)?.valueOf())
                                    })
                                } }
                                disabled={ isPreview }
                            />
                        </Grid2>
                        <Grid2 size={6}>
                            <Input
                                id='startDateHour'
                                title={ i18n.startHour }
                                value={ getHour(startDate) }
                                onChange={ v => {
                                    onChangeHour(v, v2 => {
                                        return setStartDate(getDateWithHour(startDate, v2).valueOf())
                                    })
                                } }
                                disabled={ isPreview }
                            />
                        </Grid2>
                        <Grid2 size={6}>
                            <Input
                                id='endDate'
                                value={ getDate(endDate) }
                                title={ i18n.endDate }
                                onChange={ v => {
                                    onChangeDate(v, v2 => {
                                        return setEndDate(getDateWithHour(v2, endDate).valueOf())
                                    })
                                } }
                                disabled={ isPreview }
                            />
                        </Grid2>
                        <Grid2 size={6}>
                            <Input
                                id='endDateHour'
                                title={ i18n.endHour }
                                value={ getHour(endDate) }
                                onChange={ v => {
                                    onChangeHour(v, v2 => {
                                        return setEndDate(getDateWithHour(endDate, v2).valueOf())
                                    })
                                } }
                                disabled={ isPreview }
                            />
                        </Grid2>
                    </Grid2>
                    <ValidationSeeMoreCriterias
                        selectFilters={selectFilters}
                        changeSelectFilters={changeSelectFilters}
                        isValidateActive={isPreview}
                    />
                </StyledFieldSet>
                <Grid2 container className='padding-1' justifyContent='center'>
                    <Button
                        tooltip={ i18n.apply }
                        onClick={ onValidate }
                        icon='border_color'
                        className='btn-floating btn-large'
                        disabled={ isPreview }
                    />
                    <Button
                        tooltip={ i18n.cancel }
                        onClick={ onCancel }
                        icon='cancel'
                        className='red btn-floating btn-large margin-left-2 margin-right-2'
                        disabled={ !isPreview }
                    />
                    <Button
                        tooltip={ i18n.register }
                        onClick={ onSave }
                        icon='save'
                        disabled={ !isPreview }
                        className={ `btn-floating btn-large ${isPreview ? 'pulse' : ''}` }
                    />
                </Grid2>
            </WhiteCard>
        </div>

    )
}


DeleteHydroToolPanel.propTypes = {
    id: PropTypes.number,
    dataType: PropTypes.number,
    selectedCodePoint: PropTypes.number,
    startDate: PropTypes.number,
    setStartDate: PropTypes.func,
    endDate: PropTypes.number,
    setEndDate: PropTypes.func,
    isChange: PropTypes.bool,
    setIsChange: PropTypes.func,
    isPreview: PropTypes.bool,
    setIsPreview: PropTypes.func,
    createTechnicalEvent: PropTypes.func,
    measuresSelectedByFilters: PropTypes.arrayOf(measureHydroType),
    displayModes: PropTypes.objectOf(PropTypes.bool),
    displayCote: PropTypes.number,
    nextMeasure: measureHydroType,
    hydroMeasuresFormat: PropTypes.arrayOf(measureHydroType),
    selectFilters: validationSelectFiltersType,
    changeSelectFilters: PropTypes.func,
    useNGF: PropTypes.bool,
    landmarkValue: PropTypes.number,
}

export default DeleteHydroToolPanel

